import React from "react";
import Chip from "@mui/material/Chip";

export interface InteractionPropsDisplayProps {
  text: string;
  avatar: any;
  label: string;
  variant: any;
}

const InteractionPropsDisplay = (props: InteractionPropsDisplayProps) => {
  let style: any = {
    paddingTop: "30px",
    paddingBottom: "30px",
    paddingLeft: "25px",
    paddingRight: "25px",
    marginLeft: "5px",
    marginRight: "5px",
  };
  if (props.variant === "filled") {
    style = {
      paddingTop: "30px",
      paddingBottom: "30px",
      paddingLeft: "25px",
      paddingRight: "25px",
      marginLeft: "5px",
      marginRight: "5px",
      border: "1pt solid white",
    };
  }

  return (
    <Chip
      style={style}
      label={
        <div>
          <div style={{ fontSize: "10pt", fontStyle: "italic" }}>
            {props.label}
          </div>
          <div style={{ fontSize: "15pt" }}>{props.text}</div>
        </div>
      }
      avatar={props.avatar}
      variant={props.variant}
      color="primary"
      size="medium"
    />
  );
};

export default InteractionPropsDisplay;
